import { render, staticRenderFns } from "./PkRank.vue?vue&type=template&id=77e84ffc&scoped=true&"
import script from "./PkRank.vue?vue&type=script&lang=js&"
export * from "./PkRank.vue?vue&type=script&lang=js&"
import style0 from "./PkRank.vue?vue&type=style&index=0&id=77e84ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e84ffc",
  null
  
)

component.options.__file = "PkRank.vue"
export default component.exports